import { BRAND_GATEWAY } from '../../constants'

const getBrandGatewayBreadcrumbItemByTaskId = ({
  id,
  isCurrentViewAutoResolved,
}) => ({
  path: `/tasks/brand-gateway/${id}`,
  type: BRAND_GATEWAY,
  name: 'Brand Gateway',
  isCurrentViewAutoResolved,
})

export default getBrandGatewayBreadcrumbItemByTaskId
